import * as React from 'react';
import { InlineText3 } from '@cian/ui-kit';
import { SolidZhk16 } from '@cian/ui-kit/prev';
import * as styles from './NewBuildingCardListed.css';

interface INewBuildingCardListedProps {
  images: React.ReactNode[];
  title: React.ReactNode;
  isReliable: boolean;
  promo: React.ReactNode;
  labels: React.ReactNode;
  finishLabel: React.ReactNode;
  subwayInfo: React.ReactNode;
  address: React.ReactNode;
  apartments: React.ReactNode;
  detailsButton: React.ReactNode;
  seeAll: React.ReactNode;
  morePhotoUrl?: string;
}

export function NewBuildingCardListed({
  images,
  title,
  isReliable,
  promo,
  labels,
  finishLabel,
  subwayInfo,
  address,
  apartments,
  detailsButton,
  seeAll,
  morePhotoUrl,
}: INewBuildingCardListedProps) {
  return (
    <article className={styles['card']}>
      <div className={styles['card__media']}>
        {promo && <div className={styles['card__promo']}>{promo}</div>}

        <ul className={styles['card__image-list']}>
          {React.Children.map(images, (item, index) => (
            <li key={index} className={styles['card__image-item']}>
              {item}

              {morePhotoUrl && index === images.length - 1 && (
                <a href={morePhotoUrl} target="_blank" rel="noopener noreferrer" className={styles['card__image-more']}>
                  <InlineText3 color="white_100">Еще фото</InlineText3>
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className={styles['card__description']}>
        <div className={styles['card__labels']}>{labels}</div>
        <div className={styles['card__title']}>
          {title}

          {isReliable && (
            <span className={styles['card__reliable']}>
              <SolidZhk16 color="primary_100" />
            </span>
          )}
        </div>

        <div className={styles['card__finish']}>{finishLabel}</div>
        <div className={styles['card__subway']}>{subwayInfo}</div>
        {address}

        {apartments && <div className={styles['card__apartments']}>{apartments}</div>}

        <div className={styles['card__info-buttons']}>
          <div className={styles['card__details']}>{detailsButton}</div>

          {seeAll}
        </div>
      </div>
    </article>
  );
}
